export enum INFO_CONSTANTS {
  BOOKING_NUMBER = 'Booking Number',
  PATIENT_ACTIVITY_TITLE = 'Real-time Patient Tracker',
  STAFF = 'Staff',
  CANT_EDIT = 'You can’t edit/change this booking',
  LEASE_VALUE = 'Booking value',
  MEDIA = 'Media',
  PATIENT_ACTIVITY = 'Patient Schedule',
  DOCUMENTS = 'Documents',
  CONTRACTS = 'Contracts',
  LEASE_MEDICAL_STAFF = 'Book’s Medical Staff',
  BILLING = 'Billing',
  REAL_TIME_ACTIVITY = 'Real time activity',
  ACTIVITY_HISTORY = 'Movement history today',
  PRE_POPULATE_USING = 'Pre-populate schedules using',
  DEFAULT_APPT = 'Default appt',
  TIME_SLOTS = 'time slots',
  MEDIA_DESCRIPTION = 'One or more rooms that you booked, give you the possibility to display custom images (diplomas, certificates, etc) for your patients, on dedicated displays',
  STILL_ACTIVE = 'The booking is still active',
  SELECT_DRAG = 'Select a file or drag and drop here',
  FILE_TYPES = 'JPG or PNG, file size no more than 10MB',
  DIMENSIONS = 'Image dimensions: max 1920x1080px',
  SHOP = 'Shop',
  OPTIONS = 'Options',
  ASSIGNED_ROOM = 'Assigned room',
  AFTER_LEASE = 'Room condition after the booking ends',
  BEFORE_LEASE = 'Room condition before booking start',
  SHOP_DESCRIPTION = 'The following services are available for purchase during the day of the booking:',
  DISPLAY = 'Display ',
  CURRENT_DAY_MESSAGE = 'You can only make changes for the next days of your booking. If you want to make changes for today please go to ',
  PAST_DAY_MESSAGE = 'You can not make changes for the past days of your booking',
  ADD_PATIENT = 'Add patient',
  ADD_WALK_IN_PATIENT = 'Add walk-in patient',
  EDIT_WALK_IN_PATIENT = 'Edit walk-in patient',
  EDIT_PATIENT = 'Edit patient',
  ADD_APPOINTMENT = 'Add appointment',
  EDIT_APPOINTMENT = 'Edit appointment',
  OPEN_PATIENT_CHART = 'Open patient chart',
  VIEW_IN_CHART = 'Chart',
  NO_ACTIVE_LEASES_TODAY = 'No active bookings today',
  NO_ACTIVE_SCHEDULE_TODAY = "You don't have a booking for this date, would you like to book it?",
  NO_CONSULTATION_STAFF_SELECTED = 'No consultation staff selected',
  SAME_TIME_ALLOWED_PATIENTS = 'Maximum number of people allowed in simultaneously',
  CURRENT_PATIENTS_IN_WAITING_ROOM = 'Current number of patients in the waiting room',
  REMOVE_PATIENT = 'This will delete the appointment record',
  PATIENT_CODE = "Patient's code",
  NOTIFY_PATIENT = 'Notify patient',
  STATUS = 'Status:',
  LOCATION = 'Location:',
  NOW_IN = 'Now in:',
  MULTIPLE_PATIENTS_TITLE = 'You already have one patient in this room',
  DOCTOR_AWAY_TITLE = 'Doctor is away',
  DOCTOR_AWAY_WARNING = 'The doctor is away or outside available hours during this appointment. Do you still want to create it?',
  CONTINUE = 'Continue',
  CURRENT_TIME_EXCEEDED = 'Your selected start time has passed. Change the appointment start time to the current time?',
  TIME_OUTSIDE_SCHEDULE = 'Your selected end time is outside of the booking schedule!',
  ATTENTION = 'Attention',
  ARE_YOU_SURE = 'Are you sure?',
  YES = 'Yes',
  INFO = 'Info',
  CONTRACT = 'contract',
  BUSY_ROOM_WARNING = 'You can’t add or update the start time of patients appointment while room status is set to busy',
  DISABLED_INTERVAL_WARNING = `You can't schedule an appointment during unavailable slots.`,
  NOTIFY_PATIENTS_WARNING_TITLE = 'Notify patients',
  NOTIFY_PATIENTS_WARNING = 'Are you sure you want to notify your patients via Text Message?',
  SUCCESS_SMS = 'Message sent successfully',
  HIPAA_SMS_NOT_ALLOW = 'Text message not allowed for this patient',
  FAILED_SMS = 'There was an error sending the message',
  PHONE_NOT_SET_SMS = 'Phone number not set',
  PENDING_SEND_SMS = 'Message scheduled',
  REASON = 'Reason: ',
  LAST_SMS_SENT = 'Last Text Message sent on',
  ERROR = 'Error: ',
  NO_ACTIVE_ROOMS_TODAY = 'The booking it’s not ready yet, you will be able to manage it after 06:00 AM',
  GAP_LIMIT_ERROR = 'The start and end time gap should be a minimum of 5 minutes.',
  TIME_BETWEEN = 'Please enter a time between ',
  AND = 'and',
  INVALID_TIME = 'Invalid time',
  NO_MUSIC_OPTION = 'No ambient music',
  DEFAULT_PATIENTS_LANGUAGE = 'English (United States)',
  PLEASE_SELECT_START_TIME = 'Please select the start time',
  PLEASE_SELECT_END_TIME = 'Please select the end time',
  EARLY_END_TIME_ERROR_MESSAGE = 'End time cannot be earlier than or equal to start time',
  EARLY_END_TIME_FIVE_MINUTES_GAP_ERROR = 'End time should be at least 5 minutes later than start time',
  END_OF_THE_PROGRAM = 'End time should be at least 5 minutes later than start time and before closing the program',
  ARE_YOU_SURE_TERMINATE_LEASE = 'Are you sure you want to complete booking',
  NOTE = 'Note',
  SITE_MANAGER = 'Site Manager',
  CANCEL_NOTE_1 = 'You must contact the',
  CANCEL_NOTE_2 = ' and schedule a date and time to remove your equipment. Until this is completed, your booking will continue to be in effect.',
  EHR = 'EHR',
}

export const PATIENT_SCHEDULE_SCROLL_HEIGHT_OFFSET = 239
export const CHECK_FOR_DISABLED_CHANGE_ROOM_STATUS_INTERVAL = 60000

// const UNCONFIRMED_STATUS_CODE = 1
// const CONFIRMED_STATUS_CODE = 2
// const REFUSED_STATUS_CODE = 3
// const CANCEL_DOCTOR_STATUS_CODE = 4
// const CHECKED_IN_STATUS_CODE = 5
// const CHECKED_OUT_STATUS_CODE = 6
// const WALK_IN_STATUS_CODE = 7
// const NO_SHOW_STATUS_CODE = 8
// const NO_ACCESS_STATUS_CODE = 9
// const DELETED_STATUS_CODE = 10
// const RESCHEDULE_STATUS_CODE = 11
// const NONE_STATUS_CODE = 12
// const CANCEL_PATIENT_STATUS_CODE = 13
// const CANCEL_24H_STATUS_CODE = 14
// const OPERATOR_ERROR_STATUS_CODE = 15
// const AVM_CONFIRMED_STATUS_CODE = 16
// const IN_ROOM_STATUS_CODE = 17
// const CANCELLATION_POLICY_REMINDER_STATUS_CODE = 18
// const OUT_OF_ROOM_STATUS_CODE = 19

export enum PATIENT_STATUSES {
  DISABLED = 0,
  UNCONFIRMED = 1,
  CONFIRMED = 2,
  REFUSED = 3,
  CANCELED = 4,
  CHECKED_IN_ON_SITE = 5,
  CHECKED_OUT = 6,
  WALK_IN = 7,
  NO_SHOW = 8,
  CHECK_IN_REJECTED = 9,
  DELETED = 10,
  RESCHEDULE = 11,
  NONE = 12,
  CANCEL_PATIENT = 13,
  CANCELED_24H = 14,
  OPERATOR_ERROR = 15,
  AVM_CONFIRMED = 16,
  IN_EXAM_ROOM = 17,
  CANCELLATION_POLICY_REMINDER = 18,
  OUT_OF_EXAM_ROOM = 19,
  IN_CALL = 20,
}

export const PATIENT_STATUS_NAMES = {
  [PATIENT_STATUSES.DISABLED]: 'Disabled',
  [PATIENT_STATUSES.UNCONFIRMED]: 'Unconfirmed',
  [PATIENT_STATUSES.CONFIRMED]: 'Confirmed',
  [PATIENT_STATUSES.REFUSED]: 'Refused',
  [PATIENT_STATUSES.CHECKED_IN_ON_SITE]: 'Checked in on site',
  [PATIENT_STATUSES.CANCELED]: 'Canceled',
  [PATIENT_STATUSES.CHECKED_OUT]: 'Checked out',
  [PATIENT_STATUSES.WALK_IN]: 'Walk-in',
  [PATIENT_STATUSES.NO_SHOW]: 'No show',
  [PATIENT_STATUSES.CHECK_IN_REJECTED]: 'No access',
  [PATIENT_STATUSES.DELETED]: 'Deleted',
  [PATIENT_STATUSES.RESCHEDULE]: 'Reschedule (Canceled)',
  [PATIENT_STATUSES.IN_CALL]: 'In call',
}

export enum APPOINTMENT_CATEGORY_NAMES {
  OFFICE_VISIT = 'Office Visit',
}

export enum APPOINTMENT_CATEGORY_CODES {
  HOUSE_CALL = 17,
  TELEHEALTH = 19,
}

export const REMOTE_APPOINTMENT_CATEGORY_CODES: number[] = [
  APPOINTMENT_CATEGORY_CODES.HOUSE_CALL,
  APPOINTMENT_CATEGORY_CODES.TELEHEALTH,
]

export enum ROOM_STATUS {
  BUSY = 1,
  FREE = 2,
  CLEANUP = 3,
  DISABLE = 4,
}

export const ROOM_STATUS_NAMES = {
  [ROOM_STATUS.BUSY]: 'Busy',
  [ROOM_STATUS.FREE]: 'Free',
  [ROOM_STATUS.CLEANUP]: 'Cleanup',
  [ROOM_STATUS.DISABLE]: 'Disabled',
}

export enum ACTION_TYPES {
  RESCHEDULE,
  RESIZE_SCHEDULE,
  DELETE,
  CANCEL,
  CHECK_OUT,
  EDIT_TEMPERATURE,
  EDIT_CONSULTATION_STAFF,
}

export const ACTION_MESSAGE = {
  [ACTION_TYPES.RESCHEDULE]: 'Reschedule',
  [ACTION_TYPES.RESIZE_SCHEDULE]: 'Change duration',
  [ACTION_TYPES.DELETE]: 'Delete',
  [ACTION_TYPES.CANCEL]: 'Cancel',
  [ACTION_TYPES.CHECK_OUT]: 'Check out',
  [ACTION_TYPES.EDIT_TEMPERATURE]: 'Edit temperature',
  [ACTION_TYPES.EDIT_CONSULTATION_STAFF]: 'Change provider',
}

export const APPOINTMENT_STATUS_ALLOWED_ACTIONS: Partial<Record<PATIENT_STATUSES, ACTION_TYPES[]>> =
  {
    [PATIENT_STATUSES.UNCONFIRMED]: [
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.DELETE,
      ACTION_TYPES.CANCEL,
      ACTION_TYPES.EDIT_TEMPERATURE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
    [PATIENT_STATUSES.CONFIRMED]: [
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.DELETE,
      ACTION_TYPES.CANCEL,
      ACTION_TYPES.EDIT_TEMPERATURE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
    [PATIENT_STATUSES.REFUSED]: [ACTION_TYPES.DELETE, ACTION_TYPES.CANCEL],
    [PATIENT_STATUSES.CANCELED]: [ACTION_TYPES.DELETE],
    [PATIENT_STATUSES.CANCELED_24H]: [ACTION_TYPES.DELETE],
    [PATIENT_STATUSES.CHECKED_IN_ON_SITE]: [
      ACTION_TYPES.CHECK_OUT,
      ACTION_TYPES.DELETE,
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
    [PATIENT_STATUSES.WALK_IN]: [
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.DELETE,
      ACTION_TYPES.EDIT_TEMPERATURE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
    [PATIENT_STATUSES.CHECKED_OUT]: [ACTION_TYPES.DELETE],
    [PATIENT_STATUSES.DISABLED]: [],
    [PATIENT_STATUSES.CHECK_IN_REJECTED]: [
      ACTION_TYPES.DELETE,
      ACTION_TYPES.CANCEL,
      ACTION_TYPES.EDIT_TEMPERATURE,
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
    ],
    [PATIENT_STATUSES.NO_SHOW]: [
      ACTION_TYPES.DELETE,
      // ACTION_TYPES.CANCEL,
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.EDIT_TEMPERATURE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
    [PATIENT_STATUSES.DELETED]: [],
    [PATIENT_STATUSES.RESCHEDULE]: [],
    [PATIENT_STATUSES.IN_EXAM_ROOM]: [
      ACTION_TYPES.CHECK_OUT,
      ACTION_TYPES.DELETE,
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
    [PATIENT_STATUSES.OUT_OF_EXAM_ROOM]: [
      ACTION_TYPES.CHECK_OUT,
      ACTION_TYPES.DELETE,
      ACTION_TYPES.RESCHEDULE,
      ACTION_TYPES.RESIZE_SCHEDULE,
      ACTION_TYPES.EDIT_CONSULTATION_STAFF,
    ],
  }

export const COUNT_AS_OVERLAPPING = [
  PATIENT_STATUSES.CONFIRMED,
  PATIENT_STATUSES.CHECKED_IN_ON_SITE,
  PATIENT_STATUSES.WALK_IN,
  PATIENT_STATUSES.UNCONFIRMED,
  // PATIENT_STATUSES.NO_SHOW,
]

export const ALLOW_RESCHEDULE_CURRENT_DAY_PAST_EVENTS = [
  PATIENT_STATUSES.CONFIRMED,
  PATIENT_STATUSES.UNCONFIRMED,
  PATIENT_STATUSES.CHECKED_IN_ON_SITE,
  PATIENT_STATUSES.WALK_IN,
  PATIENT_STATUSES.NO_SHOW,
  PATIENT_STATUSES.CHECK_IN_REJECTED,
]

export enum PUSHER_EVENTS {
  PATIENT_UPDATED = 'patient_update',
  PATIENT_CREATE = 'patient_create',
  PATIENT_DELETE = 'patient_delete',
  PATIENT_LOCATION_UPDATE = 'patient_location_update',
  PATIENT_STATUS_UPDATE = 'patient_status_update',
  MASS_UPDATE = 'mass_update',
  ROOM_STATUS_UPDATE = 'room_status_update',
}

export const STATUSES_TO_BE_HIDDEN_IN_PATIENT_ACTIVITY = [
  PATIENT_STATUSES.CANCELED,
  PATIENT_STATUSES.REFUSED,
]

export enum SMS_STATUSES {
  UNCONFIRMED = 'unconfirmed',
  PENDING = 'pending',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  PHONE_NOT_SET = 'phone_not_set',
  HIPAA_SMS_NOT_ALLOW = 'hipaa_sms_not_allow',
}

export const MIN_SCHEDULE_TIME_IN_MINUTES = 5
export const MIN_LONG_PRESS_TO_ADD_SCHEDULE_MS = 5
export const MIN_PRE_POPULATE_TIME = 5
